var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "landing hero is-primary is-fullheight" },
    [_c("TheNavbar"), _vm._m(0)],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "hero-body" }, [
      _c("div", { staticClass: "container has-text-centered" }, [
        _c("h1", { staticClass: "title" }, [
          _vm._v("\n        Machete\n      ")
        ]),
        _c("h2", { staticClass: "subtitle" }, [
          _vm._v("\n        The Financial Solution\n      ")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }